import React from 'react'

import { useStore } from '../functions/store'
import NavigationMenu from './Navbar'

// Define the props for the Header component
type HeaderProps = {
  slug: string
}

export const Header = ({ slug }: HeaderProps) => {
  const user = useStore((state) => state)
  const isAvaliacao360 = slug.startsWith('/avaliacao')

  let mainMenu = <NavigationMenu user={null} />

  if (isAvaliacao360) {
    mainMenu = <NavigationMenu user={user} isAvaliacao360={true} />
  }

  return (
    <header>
      <div className="container mx-auto">{mainMenu}</div>
    </header>
  )
}
